import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { takeUntil } from 'rxjs/operators';
import { UserType } from '../../enums/shared-enums.enum';
import { LayoutService } from '../../../../layout/services/layout.service';
import { UserApi } from '@shared-features/services';

@Component({
  selector: 'app-view-edit-user-page',
  templateUrl: './view-edit-user-page.component.html',
  styleUrls: ['./view-edit-user-page.component.scss'],
})
export class ViewEditUserPageComponent extends BaseComponent implements OnInit {
  userType: UserType;
  userId: string;
  allowEdit = true;
  userName: string;
  isCustomer: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,

    private userApiService: UserApi,
    public layoutService: LayoutService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.isCustomer = this.userApiService.currentUser$.value.roles[0].userType === UserType.CUSTOMER;
    if (this.router.url.includes('customers')) {
      this.userType = UserType.CUSTOMER;
     }
     else {
        this.userType = this.userApiService.currentUser$.value.roles[0].userType;
     }

    if (this.router.url.includes('view-only') || this.isCustomer) {
      this.allowEdit = false;
    }

    this.activatedRoute.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      if (params.has('userId')) {
        this.userId = params.get('userId');
      }
    });
  }
}
